<template>
    <div class="path-listen" id="monitor">
        <div v-if="ifPublic" style="height:85px;width:100%;position:relative;">
            <!-- <div style="position:absolute;left:0px;top:-10px;display:inline-block;"> -->
                <!-- <span style="color:#fff;font-size:14px;margin-right:14px;">监听时间：{{monitorTime}}</span> -->
            <!-- </div> -->
            <div style="position:absolute;right:0px;top:-10px;display:inline-block;">
                <span style="color:#fff;font-size:14px;margin-right:14px;">监听时间：{{monitorTime}}</span>
                <a-icon id="full_screen" style="color:rgba(255, 255, 255, 0.5);font-size:16px;cursor:pointer;" type="fullscreen" />
            </div>
            <div style="width:100%;height:60px;position:absolute;left:0px;top:6px;">
                <img style="width:100%;" src="../../assets/img/head-banner.png" alt="">
            </div>
            <div style="color:#fff;font-size:26px;font-weight:bold;text-align:center;">
                AI坐席监听
            </div>
            <!-- <span class="span1"></span>
            <span class="span2"></span> -->
        </div>
        <div v-if="ifPublic" style="overflow:auto;flex:1">
            <div style="width:100%;height:100%;display:flex;">
                <!-- <div class="pro-group">
                    <span class="span3"></span>
                    <span class="span4"></span>
                    <div style="width:100%;height:100%;overflow:auto;">
                        <div class="pro-list" :class="{'active':currentPro==index}" @click="queryPathlist(index,item.id,true)" v-for="(item, index) in prolistData" :key="index">
                            <div style="width:100%;height:64px;overflow:hidden;" :title='item.name'>{{item.name}}</div>
                            <span>{{item.channelCount}}</span>
                        </div>
                    </div>
                </div> -->
                <div class="pro-content" style="width:100%;height:100%;">
                    <div class="pro-body">
                        <div v-if="!ifNodata" class="title" style="height:32px;">
                            <span class="effective" @click="chooseTab('VALID')" :class="{'active':status=='VALID'}">有效</span>
                            <span class="invalid" @click="chooseTab('OVERTIME')" :class="{'active':status=='OVERTIME'}" style="margin-left:24px;">过期</span>
                            <span style="float:right;color:#fff;font-size:14px;margin-top:8px;">{{ projectName }}</span>
                        </div>
                        <img v-if="ifNodata" style="margin:auto auto;display:block;" src="../../assets/img/no-data.png" alt="">
                        <div v-if="status=='VALID'" class="item-content" style="position:relative;">
                            <div style="height:100%;overflow:auto;width:100%;">
                                <div style="">
                                    <div class="item-list" :class="{'item-list-hand':item.status=='WORKING'}" v-for="(item, index) in proObjData.channelList" :key="index" @click="showItemDetail(item,index)">
                                        <img class="item-bg" v-if="item.status=='WORKING'&&currentList!=index" src="../../assets/img/working.png" alt="">
                                        <img class="item-bg" v-if="item.status=='FREE'" src="../../assets/img/free.png" alt="">
                                        <img class="item-bg" v-if="item.status=='WORKING'&&currentList==index" src="../../assets/img/working-active.png" alt="">
                                        <div style="position:relative;" :class="{'item-list-title-working':item.status=='WORKING','item-list-title-free':item.status=='FREE'}">
                                            <span style="display:inine-block;">{{item.extentionCode}}</span>
                                            <img class="item-emoj" v-if="item.coefficientType=='NORMAL'" src="../../assets/img/normal.svg" alt="">
                                            <img class="item-emoj" v-if="item.coefficientType=='DOUBT'" src="../../assets/img/doubt.svg" alt="">
                                            <img class="item-emoj" v-if="item.coefficientType=='ANGER'" src="../../assets/img/anger.svg" alt="">
                                            <img class="item-emoj" v-if="item.coefficientType=='COMPLAINT'" src="../../assets/img/complaint.svg" alt="">
                                        </div>
                                        <div class="item-list-content">
                                            <span>{{item.status=='WORKING'?'工作中':'空闲'}}</span>
                                            <span style="float:right;padding-right:24px;">{{formatSeconds(item.duration)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="ifItemDetail" style="width:357px;height:100%;position:absolute;right:0px;top:0px;z-index:2;">
                                <div style="width:100%;height:100%;opacity:0.8;background:#04111a;position:absolute;left:0;top:0;z-index:2;"></div>
                                <div style="width:100%;height:100%;position:absolute;left:0;top:0;z-index:2;">
                                    <div style="width:100%;height:100%;position:relative;display:flex;flex-direction:column;padding:16px;">
                                        <img style="position:absolute;left:0;top:0;width:100%;height:100%;" src="../../assets/img/item-detail.png" alt="">
                                        <a-icon @click="closeDetail" style="position:absolute;right:16px;top:16px;font-size:18px;color:rgba(153, 153, 153, 1);cursor:pointer;" type="close" />
                                        <div style="width:100%;height:64px;border-bottom:1px solid rgba(255, 195, 0, 0.3);">
                                            <div style="color:rgba(255, 195, 0, 1);font-size:16px;">机器人对话实时监控-{{chatData.extentionCode}}</div>
                                            <div style="color:rgba(255, 255, 255, 0.7);font-size:12px;margin-top:6px;">{{chatData.projectName}}</div>
                                        </div>
                                        <div class="chat" id="chatDiv" style="height:100%;overflow:auto;flex:1;color:#fff;z-index:1;padding-top:16px;">
                                            <div v-for="(item, index) in chatData.recordList" :key="index">
                                                <div class="chat-list" v-if="item.role=='USER'" style="display:flex;margin-bottom:5px;">
                                                    <div v-if="item.word!=''" style="width:32px;height:32px;border-radius:16px;">
                                                        <img v-if="item.coefficientType=='NORMAL'" style="width:24px;height:24px" src="../../assets/img/normal.svg" alt="">
                                                        <img v-if="item.coefficientType=='DOUBT'" style="width:24px;height:24px" src="../../assets/img/doubt.svg" alt="">
                                                        <img v-if="item.coefficientType=='ANGER'" style="width:24px;height:24px" src="../../assets/img/anger.svg" alt="">
                                                        <img v-if="item.coefficientType=='COMPLAINT'" style="width:24px;height:24px" src="../../assets/img/complaint.svg" alt="">
                                                    </div>
                                                    <div v-if="item.word!=''" style="flex:1;padding-right:30px">
                                                        <div style="display:inline-block;padding:8px 12px;background:rgba(255, 255, 255, 0.1);color:#fff;font-size:13px;border-radius:4px;">
                                                            {{item.word}}
                                                        </div>
                                                        <div style="width:100%;height:18px;margin-top:4px;">
                                                            <div class="time" style="color:rgba(255, 255, 255, 0.5);font-size:11px;">{{item.time}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="chat-list" v-if="item.role=='ROBOT'" style="display:flex;margin-bottom:5px;">
                                                    <div v-if="item.word!=''" style="flex:1;padding-right:12px">
                                                        <div style="display:inline-block;padding:8px 12px;background:rgba(255, 255, 255, 0.1);color:#fff;font-size:13px;border-radius:4px;float:right;">
                                                            {{item.word}}
                                                        </div>
                                                        <div style="clear:both"></div>
                                                        <div style="width:100%;height:18px;margin-top:4px;">
                                                            <div class="time" style="color:rgba(255, 255, 255, 0.5);font-size:11px;float:right;">{{item.time}}</div>
                                                        </div>
                                                    </div>
                                                    <div v-if="item.word!=''" style="width:32px;height:32px;border-radius:16px;">
                                                        <img style="width:24px;height:24px" src="../../assets/img/chart.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                               
                            </div>
                        </div>
                        <div v-if="status=='OVERTIME'" class="item-content">
                            <div style="height:100%;overflow:auto;">
                                <div style="">
                                    <div class="item-list"  v-for="(item, index) in proObjData.channelList" :key="index">
                                        <img class="item-bg" src="../../assets/img/beoverdue.png" alt="">
                                        <div style="color:#fff;font-size:18px;">{{item.extentionCode}}</div>
                                        <div style="color:rgba(255, 255, 255, 0.7);font-size:12px;margin-top:4px;">已过期</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="state">
                            <div v-if="status=='VALID'" class="expression-content">
                                <div class="expression" style="color:rgba(30, 216, 255, 1);">
                                    <img src="../../assets/img/excellent.svg" alt="">
                                    <span>优秀</span>
                                </div>
                                <div class="expression" style="color:rgba(53, 108, 255, 1);">
                                    <img src="../../assets/img/normal.svg" alt="">
                                    <span>正常</span>
                                </div>
                                <div class="expression" style="color:rgba(255, 124, 26, 1);">
                                    <img src="../../assets/img/doubt.svg" alt="">
                                    <span>疑问</span>
                                </div>
                                <div class="expression" style="color:rgba(255, 0, 109, 1);">
                                    <img src="../../assets/img/anger.svg" alt="">
                                    <span>愤怒</span>
                                </div>
                                <div class="expression" style="color:rgba(255, 95, 218, 1);">
                                    <img src="../../assets/img/complaint.svg" alt="">
                                    <span>负面</span>
                                </div>
                            </div>
                            <div style="display:inline-block;float:right;margin-top:26px;">
                                <div v-if="status=='VALID'" style="display:inline-block;color:rgba(34, 215, 187, 1);margin-right:48px;">
                                    <span style="width:92px;height:44px;display:inline-block;text-align:center;line-height:44px;margin-right:16px;font-size:14px;position:relative">
                                        <img style="position:absolute;left:0;top:0;width:100%;height:100%;" src="../../assets/img/free.png" alt="">
                                        <div>空闲</div>
                                    </span>
                                    <span style="font-size:16px;">{{proObjData.freeCount}}</span>
                                </div>
                                <div v-if="status=='VALID'" style="display:inline-block;color:rgba(255, 195, 0, 1)">
                                    <span style="width:92px;height:44px;display:inline-block;text-align:center;line-height:44px;margin-right:16px;font-size:14px;position:relative">
                                        <img style="position:absolute;left:0;top:0;width:100%;height:100%;" src="../../assets/img/working.png" alt="">
                                        <div>工作中</div>
                                    </span>
                                    <span style="font-size:16px;">{{proObjData.workingCount}}</span>
                                </div>
                                <div v-if="status=='OVERTIME'" style="display:inline-block;">
                                    <span style="width:92px;height:44px;display:inline-block;text-align:center;line-height:44px;margin-right:16px;font-size:14px;position:relative">
                                        <img style="position:absolute;left:0;top:0;width:100%;height:100%;" src="../../assets/img/beoverdue.png" alt="">
                                        <div style="color:#fff;">已过期</div>
                                    </span>
                                    <span style="font-size:16px;color:rgba(255, 70, 70, 1)">{{proObjData.overtimeCount}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!ifPublic" style="display:inline-block;width:392px;height:200px;position:absolute;left:50%;margin-left:-196px;top:50%;margin-top:-100px;">
            <div style="color:#fff;font-size:20px;text-align:center;">密码访问通道监听</div>
            <a-input v-model="proPwd" style="height:48px;margin:32px 0 16px" placeholder="请输入6位数字密码" />
            <span @click="testPwd" style="background:rgba(34, 215, 187, 1);display:inline-block;width:100%;line-height:48px;border-radius:6px;color:#fff;text-align:center;font-size:14px;cursor: pointer;">验证访问密码</span>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import screenfull from "screenfull"; 
export default {
    name: 'PathListen',
    props: {
        msg: String
    },
    data() {
        return {
            ifNodata: false,
            ifItemDetail: false,
            chatData: [],
            fullscreen: false,
            currentPro: 0,
            currentList: null,
            // prolistData: [],
            proObjData: {},
            status: 'VALID',
            projectId: '',
            monitorData: 0,
            timer: null,
            timer2: null,
            currentDateTime: '',
            monitorTime: '',
            timer3: null,
            countNum: 0,
            ifPublic: false,
            proPwd: '',
            projectName: ''
        };
    },
    methods: {
        moment,
        scrollTopCon() {
            this.$nextTick(function() {
                let div = document.getElementById('chatDiv');
                div.scrollTop = div.scrollHeight;
            })
        },
        closeDetail() {
            this.ifItemDetail = false
            this.currentList = null
            clearInterval(this.timer2);
        },
        chooseTab(param) {
            this.status = param
            this.queryPathlist(null,null,false)
        },
        showItemDetail(item, index) {
            if(item.status == 'WORKING'){
                clearInterval(this.timer2);
                this.ifItemDetail = true
                this.currentList = index
                // this.currentRoom = item.room
                // this.currentId = item.id
                // this.queryTalkDetail(item.room, item.id)
                this.timer2 = setInterval(()=>{
                    this.queryTalkDetail(item.room, item.id)
                },1000)
            }
        },
        handleFullScreen(){
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        },
        // queryProlist() {
        //     this.axios(
        //         {
        //             method:'get',
        //             url:'/api/dropdown/projectWithChannel'
        //         }
        //     )
        //     .then(response=> {
        //         if(response.data.code == 0){
        //             this.prolistData = response.data.data
        //             if(this.prolistData.length > 0){
        //                 this.projectId = this.prolistData[0]['id']
        //                 this.queryPathlist(null,null,false)
        //                 this.monitorData ++
        //             }
        //         }else{
        //             this.$message.error(response.data.message);
        //         }
        //     })
        //     .catch(error=> {
        //         console.log(error)
        //     })
        // },
        queryPathlist(index,id,bool) {
            if(index != null){
                this.currentPro = index
            }
            if(id != null){
                this.projectId = id
                clearInterval(this.timer3)
            }
            this.axios(
                {
                    method:'get',
                    url:'/api/channelDataScreen/channel/list', 
                    params: {
                        projectId: this.projectId,
                        status: this.status,
                        password: this.proPwd
                    }
                }
            )
            .then(response=> {
                this.proObjData = {}
                if(response.data.code == 0){
                    this.ifPublic = true
                    this.proObjData = response.data.data
                    this.projectName = response.data.data.projectName
                    let num = 0
                    for(let i = 0; i < this.proObjData.channelList.length; i++){
                        if(this.proObjData.channelList[i].status!='FREE'){
                            num++
                        }
                    }
                    if(num!=0){
                        this.monitorTime = this.getCurrentTime()
                        this.timer3 = setInterval(()=>{
                            this.countNum++
                            this.dealData()
                            if(this.countNum==5){
                                clearInterval(this.timer3)
                                this.countNum=0
                            }
                        },1000)
                    }else{
                        this.monitorTime = ''
                    }
                    if(bool){
                        clearInterval(this.timer);
                        this.monitorData ++
                    }
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        dealData() {
            let data = this.proObjData.channelList
            for(let i = 0; i < data.length; i++){
                if(data[i]['status']=='WORKING'){
                    data[i]['duration'] = data[i]['duration']+1
                }
            }
            this.proObjData.channelList = data
            this.$forceUpdate();
        },
        formatSeconds(value) {
            let result = parseInt(value)
            let m = Math.floor((result / 60 % 60));
            let s = Math.floor((result % 60));
            let res ='';
            res += `${m}分`;
            res += `${s}秒`;
            return res;
        },
        queryTalkDetail(room, id) {
            this.axios(
                {
                    method:'get',
                    url:'/api/channelDataScreen/dialogue', 
                    params: {
                        room: room,
                        id: id
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.chatData = response.data.data
                    if(response.data.data.recordList.length == 0){
                        clearInterval(this.timer2);
                        this.ifItemDetail = false
                    }else{
                        if(this.ifItemDetail){
                            this.scrollTopCon()
                        }
                    }
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        getCurrentTime() {
            var _this = this;
            let yy = new Date().getFullYear();
            let mm = new Date().getMonth()+1;
            let dd = new Date().getDate();
            let hh = new Date().getHours();
            let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
            let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
            _this.gettime = yy + '.' + mm + '.' + dd + ' ' + hh + ':' + mf + ':' + ss;
            return _this.gettime
        },
        queryShareType() {
            this.axios(
                {
                    method:'get',
                    url:'/api/channelDataScreen/shareType', 
                    params: {
                        projectId: this.projectId,
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.shareType = response.data.data.type
                    if(this.shareType == 1){
                        this.ifPublic = true
                        this.queryPathlist(null,null,false)
                        this.listenClickEvent()
                    }else{
                        this.ifPublic = false
                    }
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        testPwd() {
            this.queryPathlist(null,null,false)
            this.listenClickEvent()

        },
        listenClickEvent() {
            //监听全屏事件
            const element = document.getElementById('monitor');
            document.getElementById('full_screen').addEventListener('click', () => {
                if (screenfull.isEnabled) {
                    screenfull.request(element); 
                }
            })
        }
    },
    mounted: function() {
        
        this.projectId = this.$route.query.projectId
        this.queryShareType()
        // this.queryProlist()
        // setInterval(()=>{
        //     this.currentDateTime = this.getCurrentTime()
        // },1000)
    },
    watch: {
        monitorData: {
            handler () {
                this.timer = setInterval(()=>{
                    this.queryPathlist(this.currentPro, this.projectId, false)
                },5000)
            },
            deep: true
        }
    },
    beforeRouteLeave(to, from, next){
        next();
        clearInterval(this.timer);
        clearInterval(this.timer2);
    },
}
</script>

<style scoped  lang="less">
    ::-webkit-scrollbar {
        width: 0px;  
        height: 0px;  
    }  
    .path-listen{
        width: 100%;
        height: 100%;
        background: rgba(4, 17, 26, 1);
        padding: 26px 22px 70px 22px;
        display:flex;
        flex-direction: column;
        position: relative;
        .span1{
            width:4px;
            height:4px;
            display:inline-block;
            background:rgba(66, 223, 228, 1);
            left:0px;
            bottom:0px;
            position:absolute;
        }
        .span2{
            width:4px;
            height:4px;
            display:inline-block;
            background:rgba(66, 223, 228, 1);
            left:221px;
            bottom:0px;
            position:absolute;
        }
        .pro-group{
            width:225px;
            height:100%;
            position:relative;
            border-bottom:1px solid rgba(66, 223, 228, 0.5);
            border-top:1px solid rgba(66, 223, 228, 0.5);
            
            .span3{
                width:4px;
                height:4px;
                display:inline-block;
                background:rgba(66, 223, 228, 1);
                left:0px;
                bottom:0px;
                position:absolute;
            }
            .span4{
                width:4px;
                height:4px;
                display:inline-block;
                background:rgba(66, 223, 228, 1);
                right:0px;
                bottom:0px;
                position:absolute;
            }
            .pro-list{
                width:217px;
                height:100px;
                background:rgba(255, 255, 255, 0.1);
                position:relative;
                padding:16px 16px 0;
                font-size:16px;
                margin:16px auto 0;
                cursor: pointer;
                div{
                    color:rgba(255, 255, 255, 0.8);
                    line-height:32px;
                }
                span{
                    position:absolute;
                    right:16px;
                    bottom:6px;
                    width:32px;
                    height:20px;
                    border-radius:10px;
                    color:#fff;
                    background:rgba(0, 0, 0, 1);
                    font-size:13px;
                    text-align:center;
                    line-height:20px;
                }
            }
            .pro-list.active{
                background:rgba(65, 224, 230, 0.1);
                border-left:4px solid rgba(66, 223, 228, 1);
                div{
                     color:rgba(34, 215, 187, 1);
                }
                span{
                    background:rgba(24, 144, 255, 1);
                }
            }
        }
        .pro-content{
            padding-left:48px;
            z-index: 1;
            .pro-body{
                width:100%;
                height:100%;
                display:flex;
                flex-direction: column;
                .title{
                    color:#fff;
                    font-size:14px;
                    span.effective{
                        line-height:30px;
                        display:inline-block;
                        cursor:pointer;
                    }
                    span.invalid{
                        line-height:30px;
                        display:inline-block;
                        cursor:pointer;
                    }
                    span.active{
                        color:rgba(34, 215, 187, 1);
                        border-bottom:2px solid rgba(34, 215, 187, 1);
                    }
                }
                .item-content{
                    flex:1;
                    overflow-y: auto;
                    display:flex;
                    div.item-list{
                        width:172px;
                        height:82px;
                        display:inline-block;
                        margin-right:16px;
                        margin-top:10px;
                        position: relative;
                        padding:16px 0 0 16px;
                        img.item-bg{
                            width: 100%;
                            height: 100%;
                            position: absolute;
                            left:0;
                            top:0;
                        }
                        .item-list-title-working{
                            color:rgba(255, 195, 0, 1);
                            font-size: 18px;
                        }
                        .item-list-title-free{
                            color:rgba(34, 215, 187, 1);
                            font-size: 18px;
                        }
                        .item-list-content{
                            color:rgba(255, 255, 255, 0.7);
                            font-size:12px;
                            margin-top:4px;
                        }
                        img.item-emoj{
                            position: absolute;
                            right:10px;
                            top:0;
                            width:24px;
                            height:24px;
                        }
                    }
                    div.item-list-hand{
                        cursor: pointer;
                    }
                    .chat{
                        .chat-list{
                            .time{
                                display: none;
                            }
                        }
                        .chat-list:hover{
                            div.time{
                                display: block;
                            }
                        }
                    }
                }
                .state{
                    width:100%;
                    height:70px;
                    bottom:0px;
                    left:0px;
                    .expression-content{
                        padding-top:30px;
                        display:inline-block;
                        div.expression{
                            display: inline-block;
                            font-size:14px;
                            margin-right:48px;
                            img{
                                width:26px;
                                height: 26px;
                                margin-right:8px;
                            }
                        }
                    }
                    
                }
            }
            
        }
    }
</style>
